import { PHONE_PATTERN } from '../../../utils/common';
import { FormInput } from '../../../common/components';
import { useContext } from 'react';
import { UserDetailContext, UserDetailContextProps } from '../../../context/userDetail/userDetailContext';

type YourInfoBlockProps = {};

export const YourInfoBlock = (props: YourInfoBlockProps) => {
  const { userDetail } = useContext<UserDetailContextProps>(UserDetailContext);

  return (
    <div>
      <div className='pb-3'>{`Meter upgrade request raised by - ${userDetail.emailAddress}`}</div>

      <div className='row col-12 col-xl-6'>
        <div>Contact name*</div>
        <FormInput
          name='yourContactName'
          disabled={false}
          params={{
            required: true,
          }}
        />
      </div>

      <div className='row col-12 col-xl-6'>
        <div>Contact number*</div>
        <FormInput
          name='yourPhoneNumber'
          disabled={false}
          params={{
            required: true,
            pattern: {
              value: PHONE_PATTERN,
              message: 'Please provide a valid phone number without spaces',
            },
          }}
        />
      </div>
    </div>
  );
};
